import { mapActions, mapState } from 'vuex'
import Actions from '@/constants/action'
import { upload } from '@/mixin/file'
import introImg from '@/assets/self-diagnosis-intro.jpg'
import onepage from '@/assets/onepage.png'

import anchorP1 from '@/assets/anchor-p1.jpg'
import anchorP2 from '@/assets/anchor-p2.jpg'
import anchorP3 from '@/assets/anchor-p3.jpg'
import anchorM1 from '@/assets/anchor-m1.jpg'
import anchorM2 from '@/assets/anchor-m2.jpg'
import anchorM3 from '@/assets/anchor-m3.jpg'
import studAndCompImg from '@/assets/self-diagnosis-people.png'
import countryCode from '@/config/countryCode'
import { http } from '@/api'
import { copyData } from '@/util'
import { EmployabilityAssessment, Account } from '@/api/collection'
import { getSurveyRedirectUrl, removeSurveyRedirectUrl } from '@/util/auth'
import exportPdf from './../common/exportPdf'
import { _trackEvent } from '@/util'
const questionBank = {
  'yp': [
    {
      id: 'Y1',
      wd: '1',
      base: 10,
      total: 15,
      number: '1',
      score: '',
      name: '自我认知与定位',
      list: [
        {
          id: 'Y1Q1',
          name: '自己很迷茫，寒窗苦读数十载终于毕业了，现在不知道怎么选择职业方向。不知道自身优劣势在哪里，也不知道具体行业岗位要求。',
          answer: '',
          options: [{
            label: '完全符合',
            value: 0
          }, {
            label: '不太确定',
            value: 1
          }, {
            label: '不符合',
            value: 2
          }]
        },
        {
          id: 'Y1Q2',
          name: '硕士毕业后，就业竞争压力依然巨大；自己所学专业知识面有限，似乎感觉和企业雇主的要求不怎么匹配；有时会羡慕身边同龄人可以拿到较理想的工作机会。',
          answer: '',
          options: [{
            label: '完全同意',
            value: 0
          }, {
            label: '基本同意',
            value: 1
          }, {
            label: '不确定',
            value: 0
          }]
        },
        {
          id: 'Y1Q3',
          name: '自己的学校挺一般，既不是全球QS排名Top20/50，也不是国内985/C9，想进大平台投递无门，不知道如何弥补，感觉未来没有出路。',
          answer: '',
          options: [{
            label: '完全同意',
            value: 0
          }, {
            label: '基本同意',
            value: 1
          }, {
            label: '不符合情况',
            value: 2
          }]
        },
        {
          id: 'Y1Q4',
          name: '原本打算出国读书，疫情影响太大，原计划都打乱了，现在不知道怎么合理规划空挡时间。',
          answer: '',
          options: [{
            label: '不知道',
            value: 0
          }, {
            label: '知道',
            value: 2
          }, {
            label: '不符合情况',
            value: 2
          }]
        },
        {
          id: 'Y1Q5',
          name: '最近在准备跳槽，海投简历石沉大海，好不容易进入面试环节也无疾而终，不知道问题出在哪里？手里的offer不想接，想要的offer又拿不到？',
          answer: '',
          options: [{
            label: '完全同意',
            value: 0
          }, {
            label: '基本同意',
            value: 1
          }, {
            label: '不同意',
            value: 2
          }]
        }
      ]
    },
    {
      id: 'Y2',
      wd: '1',
      base: 10,
      total: 15,
      number: '2',
      score: '',
      name: '职业规划与准备',
      list: [
        {
          id: 'Y2Q1',
          name: '作为海归应届毕业生，回国已经错过校招时间，眼看就要错过校招身份；参加社招又缺乏相关工作经验，感觉竞争很厉害；白驹过隙， 为了尽早落户，我是该先开始一份不理想的工作还是继续观望等待呢？',
          answer: '',
          options: [{
            label: '尽快工作',
            value: 0
          }, {
            label: '很难选择',
            value: 1
          }, {
            label: '继续观望',
            value: 0
          }]
        },
        {
          id: 'Y2Q2',
          name: '对现有工作不满意，学不到有用的东西，无法自我成长，离职业目标渐行渐远；但是现在工作机会又不多，毅然裸辞风险太大，继续留任又像鸡肋，不知道该如何规划准备。',
          answer: '',
          options: [{
            label: '完全赞同',
            value: 0
          }, {
            label: '基本同意',
            value: 1
          }, {
            label: '不赞同',
            value: 2
          }]
        },
        {
          id: 'Y2Q3',
          name: '近期公司内部发生了重大的人事变化或战略业务调整，有些同事坦然面对或转投更好的公司去了，自己有点无所适从，心里空荡荡的，缺乏安全感，不知道该怎么办？',
          answer: '',
          options: [{
            label: '完全赞同',
            value: 0
          }, {
            label: '基本同意',
            value: 1
          }, {
            label: '不赞同',
            value: 2
          }]
        },
        {
          id: 'Y2Q4',
          name: '现在工作状态安稳，没有太多想法，到底是这份工作真不错呢？还是自己职业危机感不够呢？不清楚下一阶段自己的职业发展将是怎么样的？无法预测自己未来可能会遇到的职场挑战？',
          answer: '',
          options: [{
            label: '深有同感',
            value: 0
          }, {
            label: '略有担心',
            value: 1
          }, {
            label: '没想过',
            value: 0
          }]
        },
        {
          id: 'Y2Q5',
          name: '进入职业瓶颈，打算自我充电，但职业转型难度很大，我到底是选择考研/出国/MBA，还是培训/考证/碎片式网络学习呢？对职业转型年轻人而言，不清楚企业最看重什么？身边也没有职业导师或成功人士给我指点迷津，我所知甚少，无法针对性提升自己，陷入迷茫。',
          answer: '',
          options: [{
            label: '完全相似',
            value: 0
          }, {
            label: '基本相似',
            value: 1
          }, {
            label: '不相似',
            value: 2
          }]
        }
      ]
    },
    {
      id: 'Y3',
      wd: '1',
      base: 8,
      total: 10,
      number: '3',
      score: '',
      name: '目标价值认同',
      list: [
        {
          id: 'Y3Q1',
          name: '我从学校课堂中所学绝大多数偏向理论知识，并不知道如何直接运用到实际工作场景中；对于行业发展与企业运作了解较少，基本属于碎片化信息堆积阶段；同时也会对于未来职业方向选择有所怀疑过。',
          answer: '',
          options: [{
            label: '同意',
            value: 0
          }, {
            label: '基本同意',
            value: 1
          }, {
            label: '没想过',
            value: 0
          }]
        },
        {
          id: 'Y3Q2',
          name: '因为自己过往的实习/工作的经历缺乏相关性，仅靠学校专业理论学习和其他实习/工作的经历，并不能获得大企业相关职位面试机会。即便参加面试也心中无底，经常失败告终。所以，现在这份工作继续做下去，对将来职业发展意义不大。',
          answer: '',
          options: [{
            label: '深有同感',
            value: 0
          }, {
            label: '基本同意',
            value: 1
          }, {
            label: '不符合情况',
            value: 1
          }]
        },
        {
          id: 'Y3Q3',
          name: '现有工作不具备很大挑战性，多为基础性任务，学不到有用的东西；眼界格局较低，很少接触新鲜事物，无法完成职场成长与自我价值实现。我认为需要有经验人士辅导带教会更有利于自我成长。',
          answer: '',
          options: [{
            label: '完全同意',
            value: 0
          }, {
            label: '基本同意',
            value: 1
          }, {
            label: '不符合情况',
            value: 1
          }]
        },
        {
          id: 'Y3Q4',
          name: '很羡慕身边某些同龄人的工作，感觉很充实，每天都可以学到新知识，这是给自己很好的职场锤炼，也会有不错的晋升空间。但是，自己却恰恰相反，很想跳槽或职业转型，但很清楚知道自己不具备这样的能力。',
          answer: '',
          options: [{
            label: '非常相似',
            value: 0
          }, {
            label: '暂不表态',
            value: 0
          }, {
            label: '不符合情况',
            value: 1
          }]
        },
        {
          id: 'Y3Q5',
          name: '我现在选择职业转型会产生高昂的时间成本和试错成本。年龄越大，选择更需要慎重啊！我期望找到一种有效方法降低风险并实现转型目标。',
          answer: '',
          options: [{
            label: '同意',
            value: 0
          }, {
            label: '不选择',
            value: 0
          }, {
            label: '不符合情况',
            value: 1
          }]
        }
      ]
    },
    {
      id: 'Y4',
      wd: '2',
      base: 6,
      total: 8,
      number: '4',
      score: '',
      name: '职业竞争能力 - 财务基础',
      list: [
        {
          id: 'Y4Q1',
          name: '会计是一门通用的商业语言，我的专业不是会计金融，对财务知识了解甚少。在日常工作中，我较少从财务视角解读并辅助工作；大多数情况下，我只希望把工作中的专业问题得以解决；我认为上述方面会对我将来职业发展与知识拓展造成局限。',
          answer: '',
          options: [{
            label: '完全同意',
            value: 0
          }, {
            label: '部分同意',
            value: 1
          }, {
            label: '不同意',
            value: 0
          }, {
            label: '不符合情况',
            value: 2
          }]
        },
        {
          id: 'Y4Q2',
          name: '财务管理对于企业发展与经营可以起到重要作用；财务风险管理也可以避免公司因财务结构不合理或融资不当而出现企业丧失偿债能力和投资者预期收益下降。我能熟练使用财务知识分析企业年报与财务指标并对企业战略定位和经营现状展开有深度的理解与洞察。',
          answer: '',
          options: [{
            label: '不会使用',
            value: 0
          }, {
            label: '只会一些',
            value: 0
          }, {
            label: '基本掌握',
            value: 1
          }, {
            label: '熟练使用',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'Y5',
      wd: '2',
      base: 12,
      total: 16,
      number: '5',
      score: '',
      name: '职业竞争能力 - 商务沟通',
      list: [
        {
          id: 'Y5Q1',
          name: '在较为复杂的商业环境下，我能够使用不同沟通风格和方式（书面，口语，肢体语言等）达成各项工作交流与配合目的。',
          answer: '',
          options: [{
            label: '娴熟灵活',
            value: 3
          }, {
            label: '基本无碍',
            value: 2
          }, {
            label: '一般使用',
            value: 1
          }, {
            label: '无法使用',
            value: 0
          }]
        },
        {
          id: 'Y5Q2',
          name: '在面试和商务场景下，我能够快速理解对方想法和态度并做出准确归纳，同时有针对性表达个人见解，始终保持顺畅沟通并达成商务目标。',
          answer: '',
          options: [{
            label: '灵活运用',
            value: 3
          }, {
            label: '基本无碍',
            value: 2
          }, {
            label: '勉强运用',
            value: 1
          }, {
            label: '运用困难',
            value: 0
          }]
        },
        {
          id: 'Y5Q3',
          name: '我觉得自己的人际沟通非常不错，但在公开场合就无法正常表达自己想法和见解，我有时为了公开演讲特地提前准备，但临场发挥差强人意。',
          answer: '',
          options: [{
            label: '非常符合',
            value: 0
          }, {
            label: '略有同感',
            value: 1
          }, {
            label: '完全没有',
            value: 2
          }, {
            label: '不符合情况',
            value: 2
          }]
        },
        {
          id: 'Y5Q4',
          name: '在面试或工作汇报中，经常会被对方要求简明扼要阐述个人观点，自己总觉得很难做到，是我的语言表达能力有问题吗？',
          answer: '',
          options: [{
            label: '经常发生',
            value: 0
          }, {
            label: '偶尔发生',
            value: 1
          }, {
            label: '几乎没有',
            value: 2
          }, {
            label: '不清楚',
            value: 1
          }]
        }
      ]
    },
    {
      id: 'Y6',
      wd: '2',
      base: 6,
      total: 8,
      number: '6',
      score: '',
      name: '职业竞争能力 - 商业敏锐',
      list: [
        {
          id: 'Y6Q1',
          name: '对于当今各大主流热门行业都有较深刻了解，可以对任一行业的发展现状和未来发展趋势表达出自己的看法，对行业内主要玩家及盈利模式也有一定深度的理解。',
          answer: '',
          options: [{
            label: '知晓甚少',
            value: 0
          }, {
            label: '有所了解',
            value: 1
          }, {
            label: '知晓甚多',
            value: 2
          }, {
            label: '不确定',
            value: 0
          }]
        },
        {
          id: 'Y6Q2',
          name: '对于当今主流行业所面临的市场机遇和风险有较深刻了解，能够通过一些代表性企业的市场表现来阐述市场盈利模式和战略框架。',
          answer: '',
          options: [{
            label: '一无所知',
            value: 0
          }, {
            label: '知晓甚少',
            value: 1
          }, {
            label: '有所了解',
            value: 2
          }, {
            label: '知晓甚多',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'Y7',
      wd: '2',
      base: 6,
      total: 8,
      number: '7',
      score: '',
      name: '职业竞争能力 - 企业运营',
      list: [
        {
          id: 'Y7Q1',
          name: '能够掌握最基本的企业管理知识并了解市场经济概念，深度理解企业组织架构搭建与管理效应，跨职能项目协作与关系管理以及企业内部制定商业计划基本流程等。',
          answer: '',
          options: [{
            label: '知晓甚少',
            value: 0
          }, {
            label: '有所了解',
            value: 1
          }, {
            label: '知晓甚多',
            value: 2
          }, {
            label: '不确定',
            value: 0
          }]
        },
        {
          id: 'Y7Q2',
          name: '具备一定的项目管理经验并能够把控项目实施过程中主要关键环节，有效整合内外部资源并良好衔接，保证项目合规落地并推动企业价值最大化。',
          answer: '',
          options: [{
            label: '知晓甚少',
            value: 0
          }, {
            label: '有所了解',
            value: 1
          }, {
            label: '知晓甚多',
            value: 2
          }, {
            label: '不确定',
            value: 0
          }]
        }
      ]
    },
    {
      id: 'Y8',
      wd: '2',
      base: 12,
      total: 16,
      number: '8',
      score: '',
      name: '职业竞争能力 - 解决问题与创新',
      list: [
        {
          id: 'Y8Q1',
          name: '面对工作中遇到的棘手问题或突发任务经常感觉无从下手；有时候明知道问题在哪儿，但也很难想出一套满意的解决方案。',
          answer: '',
          options: [{
            label: '经常发生',
            value: 0
          }, {
            label: '偶尔发生',
            value: 1
          }, {
            label: '不会发生',
            value: 2
          }, {
            label: '不确定',
            value: 0
          }]
        },
        {
          id: 'Y8Q2',
          name: '日常工作中感觉自己效率不高，某个项目实施或商业解决方案制定经常要花很多时间，无法既高效又准时完成既定任务，有点力不从心。',
          answer: '',
          options: [{
            label: '经常发生',
            value: 0
          }, {
            label: '偶尔发生',
            value: 1
          }, {
            label: '不会发生',
            value: 2
          }, {
            label: '不确定',
            value: 0
          }]
        },
        {
          id: 'Y8Q3',
          name: '在规定期限内能够通过各种途径快速收集有效信息并对某个特定领域做出全面丰富的分析研究；也可以使用不同的分析工具对大量数据进行整理与分析，最终找出数字背后的规律及问题所在。',
          answer: '',
          options: [{
            label: '灵活使用',
            value: 2
          }, {
            label: '一般使用',
            value: 1
          }, {
            label: '使用困难',
            value: 0
          }, {
            label: '不确定',
            value: 0
          }]
        },
        {
          id: 'Y8Q4',
          name: '在日常工作中我经常会遇到一些类似的工作挑战，面对它们时身边的同事总有不少新想法或解决方案提出来，我都觉得挺有道理，但自己就是做不到这一点。',
          answer: '',
          options: [{
            label: '经常发生',
            value: 0
          }, {
            label: '偶尔发生',
            value: 1
          }, {
            label: '不会发生',
            value: 2
          }, {
            label: '不确定',
            value: 0
          }]
        },
        {
          id: 'Y8Q5',
          name: '假设听说最近公司经营状况不太好，似乎遇到了一些麻烦，我很快就能发现公司在市场宣传，策略方向以及内部架构等方面都做了不少调整；并且面对这种情况，我经常会主动找一些正式或非正式场合与相关负责人探讨想法。',
          answer: '',
          options: [{
            label: '经常发生',
            value: 0
          }, {
            label: '偶尔发生',
            value: 1
          }, {
            label: '不会发生',
            value: 2
          }, {
            label: '不确定',
            value: 0
          }]
        }
      ]
    }
  ],
  'anchor': [
    {
      id: 'G1',
      number: '1',
      score: '',
      name: '了解自己的优势和劣势',
      list: [
        {
          id: 'G1Q1',
          name:
            '很迷茫，不知道怎么选专业? 读书十多年，我看不到自己的终点在何方，自己有什么竞争力。做了性格测试，也不知道我这种性格适合什么岗位？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G1Q2',
          name:
            '学校排名一般，想进大平台，不知道是否有机会？我都不敢申请大平台。',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G1Q3',
          name:
            '我学的是会计专业，觉得比其他非商科专业的有优势。但是，为什么发现有的同学根本没学过任何商科专业，却进了四大审计，甚至咨询?',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'G2',
      number: '2',
      score: '',
      name: '寻找拓展人脉可信资源',
      list: [
        {
          id: 'G2Q1',
          name:
            '周围同学圈子有限，没有什么有效信息。只能看公开网站，又不知道上边讲的是不是对的？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G2Q2',
          name:
            '网上信息很多，培训机构鱼龙混杂不知道，培训管不管用，老师说的是不是可信？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G2Q3',
          name:
            '申请、面试没过，也不知道为什么？面试官没空给我分析，我也不敢问，又不认识大厂的HR或高管。学长、学姐的经验也有限，也不一定有空帮我。',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G2Q4',
          name:
            '有人说想方设法在简历上写个实习就满足大厂要求了。也听HR说不是你写了大厂实习两个字就能进，他们不看重“实习”两个字，反而会受审查。我怎么才能知道谁说的对？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'G3',
      number: '3',
      score: '',
      name: '明确目标方向制定计划',
      list: [
        {
          id: 'G3Q1',
          name:
            '我怎么解决双非学校的硬伤？听说研究生大学如果不是985以上，名校，还是会只看本科大学。',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G3Q2',
          name:
            '当商赛、夏校、考证、实习冲突了，我不知道该选哪一个优先？听说有的大四前辈寒暑假全用来学习，结果找不到工作，这些努力难道白费了？商赛、大学课堂学案例与企业实际做项目有什么差别？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G3Q3',
          name:
            '不清楚商业环境下，都有什么样的工作岗位可以选择？发展前途怎么样? 如何能够知道我理想的工作是否适合我？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'G4',
      number: '4',
      score: '',
      name: '找到真的目标岗位要求',
      list: [
        {
          id: 'G4Q1',
          name:
            '不知道企业要的能力是什么？刷绩点，考研、考证、考英语、商赛，这些对通过招聘有帮助吗？我虽然忙着做这些，真的不是很清楚到底有多大帮助，只是心里安慰。',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G4Q2',
          name: '招聘要求看似一样，不同行业的岗位是不是要求不同？我该怎么准备。',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G4Q3',
          name:
            '我很想进咨询，咨询不限专业，让我不知道该学什么才能进咨询？看一些咨询方面的书管用吗？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G4Q4',
          name: '进不了大平台，我先进小平台实习。这样的实习是否会被大平台认可？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'G5',
      number: '5',
      score: '',
      name: '获得锻炼目标软硬能力',
      list: [
        {
          id: 'G5Q1',
          name:
            '我从学校和机构获得的知识都是抽象的，都是知识和行业信息堆积，还是不知道怎么用，看了也没法锻炼能力？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G5Q2',
          name:
            '感觉没有经验就拿不到实习，没有实习又没法锻炼能力，到底让我怎么解这个死循环？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G5Q3',
          name:
            '实习里做的都是一些基本工作，也学不到什么？经理都很忙，没空教，我也不敢问。',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G5Q4',
          name:
            '虽然拿到了大厂实习，但是怕做不好，拿不到好业绩反而影响再申请校招，试错成本太高，怎么办？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G5Q5',
          name:
            '外边那些机构卖实习、PTA、包进，又看到大厂官宣这些都是非法的，听说还可能把自己弄进黑名单，除了实习，还有什么方式可以得到企业要的能力？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'G6',
      number: '5.1',
      score: '',
      name: '获得锻炼目标软硬能力 - 例如：领导力',
      list: [
        {
          id: 'G6Q1',
          name:
            '面试问我如何展现领导力。我一个学生又没领导过团队，怎么能有领导力？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'G7',
      number: '5.2',
      score: '',
      name: '获得锻炼目标软硬能力 - 例如：沟通能力',
      list: [
        {
          id: 'G7Q1',
          name:
            '不少招聘要求里都写沟通能力。我平时挺能说的，为什么面试结果还说我沟通能力不行？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'G8',
      number: '5.3',
      score: '',
      name: '获得锻炼目标软硬能力 - 例如：PPT专业能力',
      list: [
        {
          id: 'G8Q1',
          name:
            '自己公开演讲就怕。觉得自己做的ppt不够专业。听咨询顾问说企业要的ppt能力并不是把ppt做的好看而已。到底怎么锻炼演讲能力，ppt怎么才算专业？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'G9',
      number: '6',
      score: '',
      name: '简历面试展示已有能力',
      list: [
        {
          id: 'G9Q1',
          name:
            '简历到底该怎么写，才能通过企业的筛选？外部模板很多不知道用哪个？不认识职场大咖帮忙修改简历，外边的机构也不确定是否靠谱？怎么办？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G9Q2',
          name:
            '很快就毕业了，别的同学都有实习经验了，我简历上很苍白，怎么办？！',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G9Q3',
          name:
            '面试没过到底为什么？哪句话我说错了？谁能告诉我？面经到底有没有用？听说看面经反而容易掉坑里。',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'G10',
      number: '7',
      score: '',
      name: '寻找创造各种面试机会',
      list: [
        {
          id: 'G10Q1',
          name:
            '怎么能够获得面试机会呢？大厂海招，千军万马过独木桥，我投了很多职位都没有反馈。',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G10Q2',
          name: '我也不敢主动联系HR。也怕自己没准备好，反而提前暴露自己。',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    },
    {
      id: 'G11',
      number: '8',
      score: '',
      name: '预备应对特殊情况',
      list: [
        {
          id: 'G11Q1',
          name:
            '死磕国外工作，但又发现错过秋招，春招名额有限，我该怎么办？在国外找工作竞争力不够，回国留学生的优势到底有多大？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G11Q2',
          name:
            '大学都是在国外读的，中国市场发展那么快，我对国内市场的环境、行业信息、商业文化、人际关系还真不如国内的同学，我该如何快速弥补？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        },
        {
          id: 'G11Q3',
          name:
            '读研、留学的计划推迟了，毕业找工作也没结果，我现在闲着该做些什么？',
          answer: '',
          options: [{
            label: '不符合',
            value: 1
          }, {
            label: '符合',
            value: 2
          }, {
            label: '非常符合',
            value: 3
          }]
        }
      ]
    }
  ]
}
export const common = {
  name: 'SelfDiagnosis',
  components: {
    exportPdf
  },
  mixins: [upload],
  data() {
    let type = this.$route.query.type
    if (type === undefined || (type !== 'anchor' && type !== 'yp')) {
      type = 'anchor'
    }
    return {
      questionList: [],
      eaType: type,
      currentPage: 0,
      introImg,
      studAndCompImg,
      onepage,
      anchorP1,
      anchorP2,
      anchorP3,
      anchorM1,
      anchorM2,
      anchorM3,
      countryCode,
      difference: {
        student: [
          '我学的理论、我考的证，到底企业看重吗？',
          '简历没通过、面试被拒了，谁能告诉我为什么？大平台到底要什么？我又不认识大企业里的HR。',
          ' 我没有大平台实习，又怎么获得大平台实战经验？ ',
          '一次高考失利就决定了我的一生吗？！双非院校硬伤怎么解？',
          '拿到了大企业offer了，我怎么准备才能获得好的实习成绩。'
        ],
        company: [
          '学历不错，但是实战能力不够！培训费用很高！',
          '经理、高级经理的工资都很高，不可能让他们全职培训新员工。但是，实习生、员工不培训又没有实战能力！',
          '让毫无经验的学生边工作边提升，成本和风险其实都挺高。',
          '测试、面试还是不能体现学生真实的能力。通过实习选拔，速度慢，能否有训练好的实战能力强的人才直接plug in?'
        ]
      },
      differenceYp: {
        student: [
          '简历海投无果、面试屡屡失败，谁能告诉我为什么？知名企业到底要什么样的人？我又不认识大平台公司HR。',
          '海归毕业回国找工作，到底有没有竞争力？现在国内就业环境到底是怎么样的？',
          '海归毕业回国找工作，到底有没有竞争力？现在国内就业环境到底是怎么样的？',
          '我是双非院校毕业，这个硬伤怎么解？',
          '毕业后工作了几年，现在遇到职业瓶颈，欲想职业转型，向大平台或更好的行业寻求发展，如何准备？',
          '学术专业限制了我毕业后第一份工作，想寻求职能岗位的转变，感觉没有任何理论和经验，该怎么办？'
        ],
        company: [
          '学校和专业还不错，但实战经验不足，新人培养很费力！',
          '海归学生太多了，又不接地气，还不如从国内985/C9学生中挑选一下。',
          '在国外学习工作太久了，对国内行业发展和经济环境了解太少了，一定水土不服，对双方都是很大挑战呀！',
          '这个岗位专业要求挺高的，没有丰富的相关岗位实习经历，缺乏竞争力。',
          '硬性条件不错，但面试完全没有状态，我们再考虑一下吧。',
          '小公司工作了挺久，专业要求和企业文化都相差甚远，不怎么门当户对吧。',
          '毕业后几段工作经历都不相关，大学专业虽然学的是这个，但总不能当校招生对待吧！'
        ]
      },
      EAForm: {
        targetJob: '',
        targetIndustry: '',
        targetJobDesc: '',
        improveContent: '',
        competitiveness: '',
        startAt: '',
        studyTime: '',
        studyFullTime: '',
        wouldSpendMoney: '',
        wishes: '',
        jobEager1: 0,
        jobExperience: '',
        jobGap1: 0,
        jobEager2: 0,
        jobGap2: 0,
        interviewQuestion1: '',
        interviewQuestion2: '',
        interviewQuestion3: '',
        challangeRate: 0,
        improvementRate: 0,
        improvementRateStatsus: 0,
        investSummerCount: '',
        investWinterCount: '',
        investWeekCount: '',
        canInvestWeekend: true,
        investCapitalMin: 0,
        investCapitalMax: 0,
        solution: '',
        solutionTarget: '',
        solutionPossibility: '',
        solutionAccording: '',
        solutionTiming: '',
        solutionCapital: '',
        solutionVerification: '',
        nextSolution: '',
        doNeedHelp: true,
        helpTopics: '',
        helpTopicsShow: '',
        helpTopicOther: '',
        timeSlot: '',
        timeSlotShow: '',
        preferedContactType: '',
        preferedContactTypeShow: '',
        // preferedTimeType: '',
        isSubmitted: true,
        isReportSent: true,
        report1: '',
        report2: '',
        eaIssues: [
          // {
          //   categoryKey: '',
          //   rate: 0,
          //   eaIssuePoints: [
          //     {
          //       pointKey: '',
          //       rate: 0,
          //       sortIndex: 0
          //     }
          //   ]
          // }
        ],
        name: '', // 姓名
        contryCode: 86, // 国家或者地区标号,
        phoneNo: '', // 手机号
        wechatId: '', // 微信号
        company: '', // 公司
        title: '', // 职位
        yearsOfWork: '', // 工作年限
        email: '', // 邮箱
        eduInstitution: '', // 学校
        grade: '', // 年级
        major: '', // 专业
        educationOrWork: 0 // 在校或在职
      },
      targetJob: { 1: '', 2: '', 3: '' },
      targetIndustry: { 1: '', 2: '', 3: '' },
      EAFormRules: {
        name: { required: true, message: '请填写姓名', trigger: 'blur' },
        phoneNo: { required: true, pattern: /^\d{6,14}$/, message: '请填写正确的手机号', trigger: 'blur' },
        email: { required: true, type: 'email', message: '请填写正确的邮箱', trigger: 'blur' },
        eduInstitution: { required: true, message: '请填写学校', trigger: 'blur' },
        grade: { required: true, message: '请选择年级', trigger: 'blur' },
        major: { required: true, message: '请填写专业', trigger: 'blur' },
        company: { required: true, message: '请填写公司', trigger: 'blur' },
        title: { required: true, message: '请选择职位', trigger: 'blur' },
        yearsOfWork: { required: true, message: '请填写工作年限', trigger: 'change' },
        wechatId: { required: true, message: '请填写微信号', trigger: 'blur' },
        targetJob: this.eaType === 'anchor' ? { required: true, message: '请填写目标公司的职位 & 期望入职的时间', trigger: 'blur' } : { required: true, message: '请填写目标岗位', trigger: 'change' },
        targetIndustry: { required: true, message: '请填写目标行业', trigger: 'change' },
        jobExperience: { required: true, message: '请填写求职经历', trigger: 'blur' },
        targetJobDesc: { required: true, message: '请填写此项', trigger: 'blur' },
        investSummerCount: { required: true, message: '请填写此项', trigger: 'blur' },
        investWinterCount: { required: true, message: '请填写此项', trigger: 'blur' },
        investWeekCount: { required: true, message: '请填写此项', trigger: 'blur' },
        investCapitalMin: { required: true, message: '请填写此项', trigger: 'blur' },
        investCapitalMax: { required: true, message: '请填写此项', trigger: 'blur' },
        helpTopicOther: { required: true, message: '请填写此项', trigger: 'blur' },
        timeSlotShow: { required: true, message: '请选择联系我的最佳时间段', trigger: 'change' },
        preferedContactTypeShow: { required: true, message: '请选择联系我的最佳方式', trigger: 'change' },
        improveContent: { required: true, message: '请填写此项', trigger: 'blur' },
        competitiveness: { required: true, message: '请填写此项', trigger: 'blur' },
        startAt: { required: true, message: '请选择何时开始', trigger: 'change' },
        studyTime: { required: true, message: '请选择时间', trigger: 'change' },
        studyFullTime: { required: true, message: '请选择时间段', trigger: 'change' },
        wouldSpendMoney: { required: true, message: '请选择资金', trigger: 'change' },
        wishes: { required: true, message: '请输入期望', trigger: 'blur' }
      },
      // login 登录
      loginDialog: false,
      loginModel: {
        contryCode: 86,
        phoneNo: '',
        email: '',
        verCode: ''
      },
      loginRules: {
        phoneNo: [{ required: true, message: '请填写手机号', trigger: 'blur' }],
        email: [
          { required: true, message: '请填写邮箱账号', trigger: 'change' }
        ],
        verCode: [
          { required: true, message: '请填写验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '请填写6位验证码', trigger: 'blur' }
        ]
      },
      timer: 0,
      getCodeBtnText: '获取验证码',
      questions: [],
      answerObj: {},
      interviewDialog: false,
      // test-result 评测结果
      explainDialog: false,
      // video 彩蛋视频
      videoDialog: false,
      // report 报表
      reportDialog: false,
      reportLoading: null
    }
  },
  computed: {
    ...mapState(['userInfo', 'lookups']),
    // 与其他同学面临问题的相似度
    selfExamScore() {
      let allScore = []
      Object.keys(this.answerObj).forEach(key => {
        allScore = allScore.concat(this.answerObj[key])
      })
      var counted = allScore.reduce((all, i) => {
        if (i in all) {
          all[i]++
        } else {
          all[i] = 1
        }
        return all
      }, {})
      const temp =
        ((0.5 * (counted['2'] || 0)) / allScore.length +
          (counted['3'] || 0) / allScore.length) *
        100
      return temp > 0 ? (temp / 10).toFixed(1) : ''
    },
    // 迷茫指数
    wishScore() {
      const temp =
        ((Number(this.EAForm.jobEager2) +
          Number(this.EAForm.jobGap2) +
          Number(this.selfExamScore)) /
          30) *
        100
      return temp > 0 ? `${temp.toFixed(1)}%` : ''
    },
    occupationalScore() {
      const scores = this.questionList.map(item => {
        if (item.wd === '1') {
          return item.score
        }
      }).filter(i => i)
      return scores.reduce((sum, current) => {
        sum += current
        return sum
      }, 0)
    },
    abilityScore() {
      const scores = this.questionList.map(item => {
        if (item.wd === '2') {
          return item.score
        }
      }).filter(i => i)
      return scores.reduce((sum, current) => {
        sum += current
        return sum
      }, 0)
    },
    questionListFilter() {
      const list = []
      this.questionList.forEach(item => {
        if ((item.id === 'G6' || item.id === 'G7' || item.id === 'G8') && item.score === 0) {
          return false
        } else {
          list.push(item)
        }
      })
      return list
    }
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val && val.token) {
          this.EAForm.phoneNo = val.phoneNo
          this.EAForm.contryCode = val.contryCode
        }
      },
      immediate: true,
      deep: true
    },
    answerObj: {
      handler(val) {
        // 计算得分
        if (this.eaType === 'anchor') {
          Object.keys(val).forEach(key => {
            var counted = val[key].reduce((all, i) => {
              if (i in all) {
                all[i]++
              } else {
                all[i] = 1
              }
              return all
            }, {})
            const temp =
              ((0.5 * (counted['2'] || 0)) / val[key].length +
                (counted['3'] || 0) / val[key].length) *
              100
            this.questionList.forEach(g => {
              if (g.id === key) {
                g.score = temp > 0 ? temp.toFixed() : 0
              }
            })
          })
        } else {
          this.questionList.forEach(g => {
            g.score = g.list.reduce((sum, current) => {
              if (current.answer) {
                sum += current.options[current.answer - 1].value
                return sum
              }
            }, 0)
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.fetchLookups()
    this.initQuestionList()
    if (this.userInfo && this.userInfo.token) {
      this.getEAForm()
    }
  },
  methods: {
    ...mapActions({
      fetchLookups: Actions.GET_LOOKUP,
      leadLogin: Actions.LOGIN
      // simpleLogin: Actions.SIMPLE_LOGIN
      // updateUserInfo: Actions.UPDATE_USER_LOCAL_INFO,
      // loginRequest: Actions.LOGIN,
      // getCampaignIdByCode: Actions.GET_CAMPAIGN_ID_BY_CODE
    }),
    initQuestionList() {
      this.questionList = questionBank[this.eaType]
      this.questions = []
      this.questionList.forEach(item => {
        this.$set(this.answerObj, item.id, [])
        item.list.forEach((question, index) => {
          this.$set(this.answerObj[item.id], index, null)
          this.questions.push({
            id: item.id,
            index, // 对应题目
            question: question.name,
            questionId: question.id,
            answer: question.answer,
            options: question.options
          })
        })
      })
      this.questions = this.questions.sort((a, b) => {
        return Math.random() > 0.5 ? -1 : 1 // 用Math.random()函数生成0~1之间的随机数与0.5比较，返回-1或1
      })
      this.$refs['EAForm'] && this.$refs['EAForm'].clearValidate()
    },
    // 上一页
    toPrevPage() {
      if (this.currentPage > 0) {
        this.currentPage--
        // 滚到顶部
        this.$nextTick(() => {
          if (this.$refs.main) {
            this.$refs.main.scrollTop = 0
          }
        })
      }
    },
    // 下一步
    async toNextPage() {
      if (this.currentPage < this.pageList.length - 1) {
        const pages = ['advantAnchor', 'advant3', 'assess', 'test', 'test1', 'test2', 'test3', 'assessAgain', 'testResult', 'endingPage']
        const currentPage = this.currentPage
        if (!pages.includes(this.pageList[currentPage])) {
          this.currentPage++
        }
        if (this.pageList[currentPage] === 'advant3' || this.pageList[currentPage] === 'advantAnchor') {
          if (!this.userInfo.token) {
            this.loginDialog = true
          }
          this.currentPage++
        }
        if (this.pageList[currentPage] === 'assess') {
          if (!this.userInfo.token) {
            this.loginDialog = true
          } else {
            let perInfoBox = false
            let perInfoForm = false
            this.$refs['perInfoBox'].validate(valid => {
              perInfoBox = valid
            })
            this.$refs['perInfoForm'].validate(valid => {
              perInfoForm = valid
            })
            if (perInfoBox && perInfoForm) {
              if (
                this.EAForm.jobEager1 === 0 &&
                this.EAForm.jobGap1 === 0 &&
                !this.EAForm.isSubmitted &&
                this.eaType === 'anchor'
              ) {
                this.$confirm(
                  '当前 “渴望程度” 和 “距离目标的差距度” 均为 0, 确认继续？',
                  '系统提示',
                  {
                    confirmButtonText: '确认',
                    cancelButtonText: '修改',
                    type: 'warning'
                  }
                )
                  .then(() => {
                    this.currentPage++
                    this.saveEAForm()
                  })
                  .catch(e => {
                    console.log(e)
                  })
              } else {
                this.currentPage++
                this.saveEAForm()
              }
            }
          }
        }

        // web端（测试页有3页）
        if (this.pageList[currentPage] === 'test1') {
          const result = []
          this.questions.slice(0, 10).forEach(item => {
            if (this.answerObj[item.id][item.index] === null) {
              result.push(false)
            }
          })
          if (result.includes(false)) {
            this.$message.warning('当前页面问题未回答完毕')
          } else {
            this.currentPage++
          }
        }
        if (this.pageList[currentPage] === 'test2') {
          const result = []
          this.questions.slice(10, 20).forEach(item => {
            if (this.answerObj[item.id][item.index] === null) {
              result.push(false)
            }
          })
          if (result.includes(false)) {
            this.$message.warning('当前页面问题未回答完毕')
          } else {
            this.currentPage++
          }
        }
        if (this.pageList[currentPage] === 'test3') {
          const result = []
          this.questions.slice(20, 30).forEach(item => {
            if (this.answerObj[item.id][item.index] === null) {
              result.push(false)
            }
          })
          if (result.includes(false)) {
            this.$message.warning('当前页面问题未回答完毕')
          } else {
            this.currentPage++
            this.saveEAForm()
          }
        }

        // 移动端（测试页只有1页）
        if (this.pageList[currentPage] === 'test') {
          const result = []
          this.questions.forEach(item => {
            if (this.answerObj[item.id][item.index] === null) {
              result.push(false)
            }
          })
          if (result.includes(false)) {
            this.$message.warning('当前页面问题未回答完毕')
          } else {
            this.currentPage++
            this.saveEAForm()
          }
        }

        if (this.pageList[currentPage] === 'assessAgain') {
          if (this.eaType === 'anchor') {
            if (
              this.EAForm.jobEager2 === 0 &&
              this.EAForm.jobGap2 === 0 &&
              !this.EAForm.isSubmitted
            ) {
              this.$confirm(
                '当前 “渴望程度” 和 “距离目标的差距度” 均为 0, 确认继续？',
                '系统提示',
                {
                  confirmButtonText: '确认',
                  cancelButtonText: '修改',
                  type: 'warning'
                }
              )
                .then(() => {
                  this.currentPage++
                  this.saveEAForm()
                })
                .catch(e => {
                  console.log(e)
                })
            } else {
              this.currentPage++
              this.saveEAForm()
            }
          } else {
            this.$refs['selfAssessAgainForm'].validate(valid => {
              if (valid) {
                this.currentPage++
                this.saveEAForm()
              }
            })
          }
        }
        if (this.pageList[currentPage] === 'testResult') {
          // let validate = false
          this.$refs['timeAndMoneyForm'].validate(async valid => {
            // validate = valid
            // })
            // this.checkInvestCapital((val) => {
            if (valid) {
              this.currentPage++
              this.saveEAForm()
            }
          })
        }
        // 滚到顶部
        this.$nextTick(() => {
          if (this.$refs.main) {
            this.$refs.main.scrollTop = 0
          }
        })
      }
    },
    // 关闭登录弹框
    closeLoginDialog() {
      if (this.pageList[this.currentPage] === 'advant') {
        this.currentPage--
      }
      this.loginDialog = false
    },
    // 保存测试题
    transformAnswer() {
      // 得分
      this.EAForm.eaIssues = []
      this.questionList.forEach(item => {
        const eaIssuePoints = []
        item.list.forEach(q => {
          eaIssuePoints.push({
            pointKey: q.id,
            rate: q.answer || 0,
            sortIndex: 0
          })
        })
        this.EAForm.eaIssues.push({
          categoryKey: item.id,
          rate: item.score || 0,
          eaIssuePoints
        })
      })
      this.EAForm.challangeRate = this.selfExamScore || 0
      this.EAForm.helpTopics = this.EAForm.helpTopicsShow.join(',')
      this.EAForm.timeSlot = this.EAForm.timeSlotShow.join(',')
      this.EAForm.preferedContactType = this.EAForm.preferedContactTypeShow.join(',')
    },
    // 保存是否需要帮助
    changeNeedHelp(val) {
      if (val === true) {
        this.EAForm.doNeedHelp = true
        this.saveEAForm()
      } else {
        this.EAForm.doNeedHelp = false
        this.EAForm.helpTopics = ''
        this.EAForm.helpTopicsShow = []
        this.EAForm.timeSlot = ''
        this.EAForm.timeSlotShow = []
        this.EAForm.preferedContactType = ''
        this.EAForm.preferedContactTypeShow = []
        this.saveEAForm()
      }
    },
    // 获取pdf url
    getPdfUrl(url) {
      this.EAForm.report1 = url
      // 提交
      this.submitEAForm()
      // 下载测试
      this.downloadPdf()
    },
    // 下载pdf
    async downloadPdf() {
      const url = await this.getFileUrl(this.EAForm.report1)
      // window.open(url)
      console.log(url)
    },
    // 获取表单
    async getEAForm() {
      const res = await http({
        path: EmployabilityAssessment.GetEAForm.path,
        method: EmployabilityAssessment.GetEAForm.method,
        data: {
          eaType: this.eaType
        }
      })
      if (res.resultCode === '0') {
        this.EAForm = copyData(Object.assign({}, this.EAForm, res.data))
        this.$set(this.EAForm, 'helpTopicsShow', this.EAForm.helpTopics ? this.EAForm.helpTopics.split(',') : [])
        this.$set(this.EAForm, 'timeSlotShow', this.EAForm.timeSlot ? this.EAForm.timeSlot.split(',') : [])
        this.$set(this.EAForm, 'preferedContactTypeShow', this.EAForm.preferedContactType ? this.EAForm.preferedContactType.split(',') : [])
        if (this.eaType === 'yp') {
          const targetIndustry = this.EAForm.targetIndustry && this.EAForm.targetIndustry.split('||') || []
          if (targetIndustry.length > 0) {
            for (let i = 0; i < targetIndustry.length; i++) {
              this.targetIndustry[i + 1] = targetIndustry[i]
            }
          }
          const targetJob = this.EAForm.targetJob && this.EAForm.targetJob.split('||') || []
          if (targetJob.length > 0) {
            for (let i = 0; i < targetJob.length; i++) {
              this.targetJob[i + 1] = targetJob[i]
            }
          }
        }
        if (this.EAForm.doNeedHelp === null) {
          this.EAForm.doNeedHelp = true
        }
        // 得先有问题
        if (this.EAForm.eaIssues && this.EAForm.eaIssues.length > 0) {
          this.EAForm.eaIssues.forEach(item => {
            this.questionList.forEach(g => {
              if (item.categoryKey === g.id) {
                g.score = item.rate
              }
            })
            item.eaIssuePoints.forEach((q, index) => {
              if (this.answerObj[item.categoryKey]) {
                this.answerObj[item.categoryKey][index] = q.rate || null
              }
            })
          })
          this.questionList.forEach(g => {
            g.list.forEach((q, index) => {
              q.answer = this.answerObj[g.id][index]
            })
          })
        }
      }
    },
    // 保存表单
    async saveEAForm() {
      if (this.EAForm.isSubmitted) {
        return
      }
      // loading
      const loading = this.$loading({
        lock: true,
        text: '正在保存,请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(45, 45, 45, 0.3)',
        customClass: 'loading'
      })
      this.EAForm.code = this.$route.query.param || this.$route.query.code || ''
      this.EAForm.eaType = this.eaType
      await this.transformAnswer()
      const res = await http({
        path: EmployabilityAssessment.SaveEAForm.path,
        method: EmployabilityAssessment.SaveEAForm.method,
        data: this.EAForm
      })
      if (res.resultCode === '0') {
        console.log(JSON.stringify(res))
      }

      loading.close()
    },
    // 提交表单
    async submitEAForm() {
      await this.transformAnswer()
      this.EAForm.eaType = this.eaType
      const res = await http({
        path: EmployabilityAssessment.SubmitEAForm.path,
        method: EmployabilityAssessment.SubmitEAForm.method,
        data: this.EAForm
      })
      if (res.resultCode === '0') {
        this.$message.success('报告已发送到邮箱, 请注意查收')
        this.getEAForm()

        this.$nextTick(() => {
          const url = getSurveyRedirectUrl()
          if (url) {
            setTimeout(() => {
              this.$router.replace({ path: url })
            }, 1000)
            setTimeout(() => {
              removeSurveyRedirectUrl()
            }, 1000)
          }
        })
        _trackEvent('Submit self diagnosis', '提交', this.userInfo.leadId, 1, 'submitEAForm')
      }
    },
    // 生成pdf
    covertToPdf() {
      if (this.$refs['exportPdf']) {
        this.$refs['exportPdf'].handleExport()
      }
    },
    // 关闭loading
    closeReportLoading() {
      if (this.reportLoading) {
        this.reportLoading.close()
      }
    },
    // 注册倒计时
    codeTimer(wait) {
      if (wait === 1) {
        this.timer = 0
        this.getCodeBtnText = '获取验证码'
      } else {
        this.timer = wait
        this.timer--
        this.getCodeBtnText = this.timer + 's'
        window.setTimeout(() => {
          this.codeTimer(this.timer)
        }, 1000)
      }
    },
    // 发送验证码
    async sendSmsCode() {
      const res = await http({
        path: Account.GetSMSVerificationCode.path,
        method: Account.GetSMSVerificationCode.method,
        data: {
          contryCode: this.loginModel.contryCode,
          phoneNo: this.loginModel.phoneNo,
          needSendtoMail: true
        }
      })
      if (res.resultCode === '0') {
        this.codeTimer(60)
      }
    },
    // login
    login() {
      this.$refs['loginForm'].validate(async valid => {
        if (valid) {
          const res = await this.leadLogin({
            contryCode: this.loginModel.contryCode,
            phoneNo: this.loginModel.phoneNo,
            verificationCode: this.loginModel.verCode,
            campaignCode: this.$route.query.param // || this.$route.query.code || this.$route.query.campaignId
          })
          if (res.resultCode === '0') {
            this.getEAForm()
            this.loginDialog = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // login() {
    //   this.$refs['loginForm'].validate(async valid => {
    //     if (valid) {
    //       const res = await this.simpleLogin({
    //         contryCode: this.loginModel.contryCode,
    //         phoneNo: this.loginModel.phoneNo,
    //         verificationCode: this.loginModel.verCode
    //       })
    //       if (res.resultCode === '0') {
    //         this.getEAForm()
    //         this.loginDialog = false
    //       }
    //     } else {
    //       console.log('error submit!!')
    //       return false
    //     }
    //   })
    // },
    // 打开报表dialog 并生成报告
    openReportDialog() {
      if (this.EAForm.doNeedHelp === true) {
        // 校验表单
        this.$refs['endingPageForm'].validate(async valid => {
          if (valid) {
            this.$confirm('提交后将不可修改, 是否继续?', '系统提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(async() => {
                // loading
                this.reportLoading = this.$loading({
                  lock: true,
                  text: '正在生成报告,请稍候...',
                  customClass: 'loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(45, 45, 45, 0.6)'
                })
                this.reportDialog = true
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.covertToPdf()
                  }, 1000)
                })
              })
              .catch(e => {
                console.log(e)
              })
          }
        })
      } else {
        this.$confirm('确认之后，我们不再提供专业指导', '系统提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async() => {
            this.reportDialog = true
            this.$nextTick(() => {
              setTimeout(() => {
                this.covertToPdf()
              }, 1000)
            })
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    // 发送报告到邮箱
    async sendEAReport() {
      await this.transformAnswer()
      this.EAForm.eaType = this.eaType
      const res = await http({
        path: EmployabilityAssessment.SendEAReport.path,
        method: EmployabilityAssessment.SendEAReport.method,
        data: this.EAForm
      })
      if (res.resultCode === '0') {
        console.log(JSON.stringify(res))
        this.$message.success('报表已发送至邮箱')
        _trackEvent('Send email', '提交', this.userInfo.leadId, 1, 'sendEAReport')
      }
    },
    // 记录答案
    answerQuestion(item, val, ind) {
      this.$set(this.answerObj[item.id], item.index, ind)
      this.$set(this, 'answerObj', this.answerObj)
      this.questionList.forEach(g => {
        if (g.id === item.id) {
          g.list.forEach(q => {
            if (q.id === item.questionId) {
              q.answer = ind
            }
          })
        }
      })
    },
    // 判断当前题目是否选择
    currentChecked(item, val) {
      if (this.answerObj[item.id][item.index] === val) {
        const values = {
          1: 'info',
          2: 'warning',
          3: 'danger',
          4: 'primary'
        }
        return values[val]
      }
      return ''
    },
    // 格式化分数
    filterScore(val) {
      if (this.eaType === 'anchor') {
        const status = [
          '自我评价良好',
          '迷茫初现，开始应对',
          '应立刻规划解决方案与行动',
          '紧迫，应当由专家协助制定解决方案与执行'
        ]
        const index = val.indexOf('%')
        const score = Number(val.substr(0, index))
        this.EAForm.improvementRate = score || 0
        if (score < 25) {
          this.EAForm.improvementRateStatsus = 0
          return status[0]
        } else if (score >= 25 && score < 50) {
          this.EAForm.improvementRateStatsus = 1
          return status[1]
        } else if (score >= 50 && score < 75) {
          this.EAForm.improvementRateStatsus = 2
          return status[2]
        } else {
          this.EAForm.improvementRateStatsus = 3
          return status[3]
        }
      } else {
        const status = [
          ['不要放弃', '目前职场状况非常糟糕，亟需寻找职业导师进行深层诊断与分析，然后再确定提升方案。'],
          ['宜早不宜晚', '目前职场状况陷入迷茫，需要立即专业化解剖与自我分析，然后尽早调整工作状态并设定职业计划。'],
          ['不忘初衷', '目前职场状况一般，需要从职业心态和自我意识出发，重点提升职场核心竞争力，软硬性技能兼备。'],
          ['勇攀高峰', '目前职场状况良好，继续保持良好的职业习惯并不断提升职场竞争力。']
        ]
        const score = val
        this.EAForm.improvementRate = score || 0
        if (score <= 30) {
          this.EAForm.improvementRateStatsus = 0
          return status[0]
        } else if (score > 30 && score <= 50) {
          this.EAForm.improvementRateStatsus = 1
          return status[1]
        } else if (score > 50 && score <= 70) {
          this.EAForm.improvementRateStatsus = 2
          return status[2]
        } else {
          this.EAForm.improvementRateStatsus = 3
          return status[3]
        }
      }
    },
    // 打开视频窗口
    openVideoDialog() {
      this.videoDialog = true
      if (this.$refs['video']) {
        this.$refs['video'].play()
      }
    },
    // 关闭视频窗口
    closeVideoDialog() {
      if (this.$refs['video']) {
        this.$refs['video'].pause()
      }
      this.videoDialog = false
    },
    studyTimeChange() {
      this.EAForm.studyFullTime = ''
      this.$nextTick(() => {
        this.$refs['timeAndMoneyForm'].clearValidate('studyFullTime')
      })
    }
  }
}
